<template>
  <div :class="$style.auth">
    <div class="pt-5 pb-5 d-flex align-items-center mt-auto">
      <img v-if="school.name" :src="school.logo" :alt="school.name" style="width:50px;" />
      <img v-else src="/resources/images/air-logo.png" alt="neoskool" />
      <div class="air__utils__logo__text">
        <div class="air__utils__logo__name text-uppercase text-dark font-size-21">{{ school.name ? school.name : 'neoskool'}}</div>
        <div
          class="air__utils__logo__descr text-uppercase font-size-12 text-gray-6"
        >{{ school.name ? 'neoskool School Management' : 'School Management'}}</div>
      </div>
    </div>
    <div class="pl-5 pr-5 pt-5 pb-5 bg-white text-center" :class="$style.container">
      <div class="text-dark font-size-30 mb-4">Reset Password</div>
      <a-form class="mb-4" :form="form" @submit="handleSubmit">
        <a-form-item>
          <a-input
            placeholder="Email Address"
            v-decorator="['email', {rules: [{ required: true, message: 'Please input your Email!' }]}]"
          />
        </a-form-item>
        <button
        @click="handleSubmit"
          type="button"
          htmlType="submit"
          class="text-center btn btn-success w-100 font-weight-bold font-size-18"
        >
        Reset my password
        </button>
      </a-form>
    </div>
    <div class="text-center font-size-18 pt-4 mb-auto">
      <router-link to="/system/login" class="font-weight-bold text-blue">
        <i class="fe fe-arrow-left align"></i> Go Back
      </router-link>
    </div>
    <div class="mt-auto pb-5 pt-5">
      <!-- <ul
        class="list-unstyled d-flex mb-2 flex-wrap justify-content-center"
        :class="$style.footerNav"
      >
        <li>
          <a href="#">Terms of Use</a>
        </li>
        <li>
          <a href="#">Compliance</a>
        </li>
        <li>
          <a href="#">Support</a>
        </li>
        <li>
          <a href="#">Contacts</a>
        </li>
      </ul> -->
      <div class="text-gray-4 text-center">© 2019 neoskool. All rights reserved.</div>
    </div>
  </div>
</template>
<script>

const subdomain = window.location.host.split('.')[0]

export default {
  name: 'AirForgotPassword',
  data: function() {
    return {
      form: this.$form.createForm(this),
      school: {},
    }
  },
  mounted: function() {
    this.loading = true
    this.$http.get(`/api/school/subdomain/${subdomain}`)
      .then(({ data }) => {
        this.school = data.data
        if (!data.data.name && subdomain !== process.env.VUE_APP_BASE) {
          this.$router.push({ path: 'system/404' })
        }
        this.loading = false
      })
      .catch(error => {
        this.$neoNotify.error(error)
      })
  },
  methods: {
    handleSubmit(e) {
      e.preventDefault()
      // this.$router.push({ name: 'resetpassword', query: { email: 'email', reset_code: 'code' } })
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$nprogress.start()
          this.$auth
            .forgotPassword(values.email, subdomain)
            .then(({ data }) => {
              this.$nprogress.done()
              this.$router.push({ name: 'resetlinksent' })
              this.$notification['success']({
                message: 'Reset link sent successfully!',
                description: 'The password reset link has been sent successfully to your registered email!',
              })
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        }
      })
    },
  },
}
</script>
<style lang="scss" module>
@import "@/components/system/Auth/style.module.scss";
</style>
